export default "__VITE_ASSET__90036705__"